import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // LOAD ORDERS
  useEffect(() => {
    const loadOrders = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(`${API_BASE}/api/VFreeOrders`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setOrders(res.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load orders.");
      }

      setLoading(false);
    };

    loadOrders();
  }, []);

  // DELETE ORDER
  const deleteOrder = async (id) => {
    if (!window.confirm("Are you sure you want to delete this order?")) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(`${API_BASE}/api/VFreeOrders/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Remove from UI
      setOrders((prev) => prev.filter((o) => o.id !== id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete order.");
    }
  };

  // FORMAT DATE
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleString("en-US");
  };

  if (loading) return <p style={{ padding: 40 }}>Loading orders...</p>;
  if (error) return <p style={{ padding: 40, color: "red" }}>{error}</p>;

  return (
    <div style={{ padding: "40px" }}>
      <h1 style={{ marginBottom: "25px" }}>VOYAH FREE — Orders</h1>

      {/* IF EMPTY */}
      {orders.length === 0 && (
        <p>No orders available yet.</p>
      )}

      {/* TABLE */}
      {orders.length > 0 && (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "white",
          }}
        >
          <thead>
            <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
              <th style={th}>ID</th>
              <th style={th}>Name</th>
              <th style={th}>Email</th>
              <th style={th}>City</th>
              <th style={th}>Offer</th>
              <th style={th}>Price</th>
              <th style={th}>Date</th>
              <th style={th}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((o) => (
              <tr key={o.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={td}>{o.id}</td>
                <td style={td}>{o.firstName} {o.surname}</td>
                <td style={td}>{o.email}</td>
                <td style={td}>{o.city}</td>
                <td style={td}>{o.offerType?.toUpperCase()}</td>
                <td style={td}>
                  {o.currency?.toUpperCase()} {o.finalPrice.toLocaleString("en-US")}
                </td>
                <td style={td}>{formatDate(o.createdAt)}</td>

                <td style={td}>
                  <button
                    style={viewBtn}
                    onClick={() => alert(JSON.stringify(o, null, 2))}
                  >
                    View
                  </button>

                  <button
                    style={deleteBtn}
                    onClick={() => deleteOrder(o.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      )}
    </div>
  );
};

// TABLE STYLES
const th = {
  padding: "12px",
  fontWeight: "600",
  fontSize: "14px",
  borderBottom: "2px solid #ddd",
};

const td = {
  padding: "12px",
  fontSize: "14px",
};

const viewBtn = {
  padding: "6px 10px",
  marginRight: "10px",
  fontSize: "13px",
  background: "#1c59ff",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

const deleteBtn = {
  padding: "6px 10px",
  fontSize: "13px",
  background: "#d11a2a",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

export default VoyahFreeOrder;
